import { createContext, useState } from 'react';

const ListsContext = createContext({});

const ListsProvider = ({ children }) => {
  const [churchMinistries, set_churchMinistries] = useState([]);
  const [groupCategories, set_groupCategories] = useState([]);
  const [leaderCategories, set_leaderCategories] = useState([]);
  const [experienceVolunteersRoles, set_experienceVolunteersRoles] = useState([]);
  const [experienceVolunteersSections, set_experienceVolunteersSections] = useState([]);
  const [data, set_data] = useState([]);

  const dataState = {
    churchMinistries,
    experienceVolunteersRoles,
    experienceVolunteersSections,
    groupCategories,
    leaderCategories,
    data,
    set_churchMinistries,
    set_experienceVolunteersRoles,
    set_experienceVolunteersSections,
    set_groupCategories,
    set_leaderCategories,
    set_data,
  };

  return <ListsContext.Provider value={dataState}>{children}</ListsContext.Provider>;
};

export { ListsContext, ListsProvider };
